import React from 'react';
import { CommonTextProps } from 'components/atoms/text/types/Props';

type PrimaryButtonProps = CommonTextProps & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function PrimaryButton({ text, styles, ...restProps }: PrimaryButtonProps) {
  return (
    <button
      type="button"
      className={`w-40 bg-slate-700 hover:bg-slate-500 px-8 sm:px-12 py-1 sm:py-2 rounded-lg text-xs sm:text-md ${styles}`}
      {...restProps}>
      {text}
    </button>
  );
}
